import util from '../..//libs/util';
import {cloneDeep} from 'lodash';


export default {
    namespaced: true,
    actions: {
        set(context, {key = '', value = ''}) {
            util.cookies.set(key, value)
        },
        get(context, {key = ''}) {
            return new Promise(resolve => {
                resolve(
                    cloneDeep(
                        util.cookies.get(key)
                    )
                )
            })
        },
        clear(context, {key = ''}) {
            return new Promise(resolve => {
                resolve(
                    util.cookies.remove(key)
                )
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/cookies.js